export const DailyRegisterPage = () => {
    return <>DailyRegisterPage</>
}